<div class="spinner-block" [class.block]="isBlock" *ngIf="show">
  <div class="spinner-screen">
    <div class="loading-spinner">
      <div class="loading fa fa-spinner fa-spin fa-5x"></div>
    </div>
  </div>
</div>
